
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { putExtend } from "@/api/product-number";
import { putExtendInquiry } from "@/api/inquiry";
@Component({
  name: "LookRemark",
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: false }) private inquiry: boolean;
  @Prop({ default: () => [] }) private remarkInfo: [];
  @Prop({ default: '' }) private productNumberId: "";
  @Prop({ default: null }) private updateExtendsOptionsCode: null;
  @Prop({ default: false }) private updateButton: boolean;
  private submitSave = false;
  private close() {
    this.$emit("update:show", false);
  }

  private addRemark() {
    this.$emit("addRemark")
  }

  private removeRemark(index) {
    this.$emit("removeRemark",index)
  }

  private async putExtendInfo() {
    this.submitSave = true
    let data = {
      req: this.remarkInfo
    }
    if(this.inquiry) {
      await putExtendInquiry(this.productNumberId,data).then(res => {
        this.submitSave = false
          this.$notify({
          title: "成功",
          message: "提交成功",
          type: "success",
          duration: 2000,
        });
        this.close()
        this.$emit("putExtendInfo")
      }).catch(err=>{
        this.submitSave = false
        console.log(err)
      })
    } else {
      await putExtend(this.productNumberId,data).then(res => {
        this.submitSave = false
          this.$notify({
          title: "成功",
          message: "提交成功",
          type: "success",
          duration: 2000,
        });
        this.close()
        this.$emit("putExtendInfo")
      }).catch(err=>{
        this.submitSave = false
        console.log(err)
      })
    }
  }
}
